/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReviewDecision } from './ReviewDecision';
import {
    ReviewDecisionFromJSON,
    ReviewDecisionFromJSONTyped,
    ReviewDecisionToJSON,
    ReviewDecisionToJSONTyped,
} from './ReviewDecision';
import type { SubmissionResultStatus } from './SubmissionResultStatus';
import {
    SubmissionResultStatusFromJSON,
    SubmissionResultStatusFromJSONTyped,
    SubmissionResultStatusToJSON,
    SubmissionResultStatusToJSONTyped,
} from './SubmissionResultStatus';
import type { AcceptedBy } from './AcceptedBy';
import {
    AcceptedByFromJSON,
    AcceptedByFromJSONTyped,
    AcceptedByToJSON,
    AcceptedByToJSONTyped,
} from './AcceptedBy';
import type { ReviewReason } from './ReviewReason';
import {
    ReviewReasonFromJSON,
    ReviewReasonFromJSONTyped,
    ReviewReasonToJSON,
    ReviewReasonToJSONTyped,
} from './ReviewReason';

/**
 * One result needing attention, with who and what it belongs to.
 * @export
 * @interface ReviewItem
 */
export interface ReviewItem {
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    submission_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    test_case_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    problem_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    problem_name: string;
    /**
     * 
     * @type {Date}
     * @memberof ReviewItem
     */
    submitted_at: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    user_id: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    user_name: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    competitor_id: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    competitor_name: string | null;
    /**
     * 
     * @type {SubmissionResultStatus}
     * @memberof ReviewItem
     */
    status: SubmissionResultStatus;
    /**
     * 
     * @type {number}
     * @memberof ReviewItem
     */
    points: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReviewItem
     */
    max_points: number;
    /**
     * 
     * @type {AcceptedBy}
     * @memberof ReviewItem
     */
    accepted_by: AcceptedBy | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReviewItem
     */
    near_match: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReviewItem
     */
    mismatch: number | null;
    /**
     * 
     * @type {ReviewDecision}
     * @memberof ReviewItem
     */
    review: ReviewDecision | null;
    /**
     * 
     * @type {Date}
     * @memberof ReviewItem
     */
    flagged_at: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    flag_comment: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReviewItem
     */
    official_output_id: string | null;
    /**
     * 
     * @type {Array<ReviewReason>}
     * @memberof ReviewItem
     */
    reasons: Array<ReviewReason>;
}



/**
 * Check if a given object implements the ReviewItem interface.
 */
export function instanceOfReviewItem(value: object): value is ReviewItem {
    if (!('submission_id' in value) || value['submission_id'] === undefined) return false;
    if (!('test_case_id' in value) || value['test_case_id'] === undefined) return false;
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('problem_name' in value) || value['problem_name'] === undefined) return false;
    if (!('submitted_at' in value) || value['submitted_at'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('user_name' in value) || value['user_name'] === undefined) return false;
    if (!('competitor_id' in value) || value['competitor_id'] === undefined) return false;
    if (!('competitor_name' in value) || value['competitor_name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('max_points' in value) || value['max_points'] === undefined) return false;
    if (!('accepted_by' in value) || value['accepted_by'] === undefined) return false;
    if (!('near_match' in value) || value['near_match'] === undefined) return false;
    if (!('mismatch' in value) || value['mismatch'] === undefined) return false;
    if (!('review' in value) || value['review'] === undefined) return false;
    if (!('flagged_at' in value) || value['flagged_at'] === undefined) return false;
    if (!('flag_comment' in value) || value['flag_comment'] === undefined) return false;
    if (!('official_output_id' in value) || value['official_output_id'] === undefined) return false;
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    return true;
}

export function ReviewItemFromJSON(json: any): ReviewItem {
    return ReviewItemFromJSONTyped(json, false);
}

export function ReviewItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewItem {
    if (json == null) {
        return json;
    }
    return {
        
        'submission_id': json['submission_id'],
        'test_case_id': json['test_case_id'],
        'problem_id': json['problem_id'],
        'problem_name': json['problem_name'],
        'submitted_at': (json['submitted_at'] == null ? null : new Date(json['submitted_at'])),
        'user_id': json['user_id'],
        'user_name': json['user_name'],
        'competitor_id': json['competitor_id'],
        'competitor_name': json['competitor_name'],
        'status': SubmissionResultStatusFromJSON(json['status']),
        'points': json['points'],
        'max_points': json['max_points'],
        'accepted_by': AcceptedByFromJSON(json['accepted_by']),
        'near_match': json['near_match'],
        'mismatch': json['mismatch'],
        'review': ReviewDecisionFromJSON(json['review']),
        'flagged_at': (json['flagged_at'] == null ? null : new Date(json['flagged_at'])),
        'flag_comment': json['flag_comment'],
        'official_output_id': json['official_output_id'],
        'reasons': ((json['reasons'] as Array<any>).map(ReviewReasonFromJSON)),
    };
}

export function ReviewItemToJSON(json: any): ReviewItem {
    return ReviewItemToJSONTyped(json, false);
}

export function ReviewItemToJSONTyped(value?: ReviewItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submission_id': value['submission_id'],
        'test_case_id': value['test_case_id'],
        'problem_id': value['problem_id'],
        'problem_name': value['problem_name'],
        'submitted_at': (value['submitted_at'] == null ? null : (value['submitted_at'] as any).toISOString()),
        'user_id': value['user_id'],
        'user_name': value['user_name'],
        'competitor_id': value['competitor_id'],
        'competitor_name': value['competitor_name'],
        'status': SubmissionResultStatusToJSON(value['status']),
        'points': value['points'],
        'max_points': value['max_points'],
        'accepted_by': AcceptedByToJSON(value['accepted_by']),
        'near_match': value['near_match'],
        'mismatch': value['mismatch'],
        'review': ReviewDecisionToJSON(value['review']),
        'flagged_at': (value['flagged_at'] == null ? null : (value['flagged_at'] as any).toISOString()),
        'flag_comment': value['flag_comment'],
        'official_output_id': value['official_output_id'],
        'reasons': ((value['reasons'] as Array<any>).map(ReviewReasonToJSON)),
    };
}

